import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'

// ROUTING
import { BrowserRouter } from 'react-router-dom'
import App from 'Containers/App'

// REDUX
import { Provider } from 'react-redux'
import store from 'Redux/store'

import * as serviceWorker from './serviceWorker'

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter basename="/">
      <App />
    </BrowserRouter>
  </Provider>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
